module.exports = __webpack_public_path__ + "static/img/dev-1.51cf0a8d.png";